import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { PageName, StoreMode } from 'src/app/core/enums';
import { UserService } from 'src/app/core/user/user.service';
import { UserQuery } from "src/app/core/user/user.query";
import { environment } from 'src/environments/environment';
import { QrScannerService } from 'src/app/core/services/qr-scanner.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ChannelQuery } from 'src/app/home/channel/channel.query';
import { ThemeService } from '../../services/theme.service';
import { ChannelService } from 'src/app/home/channel/channel.service';
import { NavigationService } from 'src/app/core/services/navigation.service';
import { User } from 'src/app/core/user/user.model';
import { UserLoginMode, UserRole } from 'src/app/core/enums';

@Component({
  selector: 'app-profile-nav-mobile',
  templateUrl: './profile-nav-mobile.component.html',
  styleUrls: ['./profile-nav-mobile.component.scss']
})
export class ProfileNavMobileComponent implements OnInit, OnDestroy {

  curUser: any;
  sub: Subscription = new Subscription();
  isLoggedIn: boolean = undefined;
  user$: Subscription;

  pageNames: any = PageName;
  customerNo: any;
  name: any;
  mobileNo: any;
  phoneNumber: string = '';
  passwordFlag: boolean = false;

  buildVersion: string = environment.version;
  channelId: number;
  profileHeaderImage: string = "assets/profile-header-image.jpg";
  displayLogin: boolean = false;
  WhatsappLoginResponse: boolean = false;
  dialogPosition: string = 'bottom';
  isDialogCenter: boolean = false;

  constructor(
    private userService: UserService,
    private userQuery: UserQuery,
    private qrScannerService: QrScannerService,
    private channelQuery: ChannelQuery,
    private themeService: ThemeService,
    private channelService: ChannelService,
    private navigationService: NavigationService
  ) {
    this.user$ = this.userQuery.isLoggedIn$.subscribe(userData => {
      this.isLoggedIn = userData && userData.id != 999 ? true : false;

      if (this.isLoggedIn) {
        this.checkLoginStatus();
      } else {
        window.addEventListener('storage', (event) => {
          if (event.storageArea == localStorage) {
            let userState = event.storageArea.getItem('eorder');

            if (userState) {
              let userStateObj = JSON.parse(userState);
              let isCurUser = userStateObj['user']?.entities[userStateObj['user']?.active];

              if (isCurUser) {
                this.userService.add({
                  ...this.curUser,
                  id: isCurUser.customerId,
                  ...isCurUser,
                  userLoginMode: UserLoginMode.LoggedIn,
                  userRole: UserRole.User,
                  isAnonymous: false
                } as User);
              }
            }
          }
        }, false);
      }
    });
  }

  async ngOnInit(): Promise<void> {
    this.themeService.checkHrefToGetChannelTag();

    await this.channelService.getChannelDataCheck();
    this.channelQuery.selectFirst().subscribe(channel => {
      if (channel) {
        this.channelId = channel.channelId;
      }
    });

    this.checkLoginStatus();

    if (this.isLoggedIn) {
      let resp: any = await this.userService.getCustomerProfileStatus(this.mobileNo, "");
      this.passwordFlag = !(resp instanceof HttpErrorResponse) ? resp.passwordFlag : this.passwordFlag;
    }
  }

  async checkLoginStatus() {
    this.sub = this.userService.get(StoreMode.Internal).subscribe((dt: any) => {
      this.curUser = dt ? dt : null;
    });

    this.customerNo = this.curUser?.customerNo ?? null;
    this.name = this.curUser ? this.curUser.name : null;
    this.mobileNo = this.curUser ? this.curUser.mobileNo : null;

    if (this.mobileNo != null) {
      this.phoneNumber = "+" + this.mobileNo.substring(0, 2) + "*****" + this.mobileNo.substring(this.mobileNo.length - 4);
    }

  }

  onLogin() {
    this.navigationService.navigate(['login'], { state: { isFromHomePage: true, showContGuest: true } });
  }

  async onLogout() {
    await this.userService.logoutInit();
  }

  onNavigate(dt: string) {
    switch (dt) {
      case 'MngAddr': {
        this.navigationService.navigate(["account", "address"]);
        break;
      }
      case 'editProfile': {
        this.navigationService.navigate(["account", "profile"]);
        break;
      }
      case 'fav': {
        this.navigationService.navigate(["account", "fav-store"]);
        break;
      }
      case 'setupPw': {
        this.navigationService.navigate(["account", "setup-password"], { state: { isProfile: true } });
        break;
      }
      case 'changePw': {
        this.navigationService.navigate(["account", "change-password"], { state: { pageName: this.pageNames.ResetPasswordPage } });
        break;
      }
      case 'paymentMtd': {
        this.navigationService.navigate(["account", "payment-method"]);
        break;
      }
      case 'RefFrd': {
        this.navigationService.navigate(["referral"]);
        break;
      }
      case 'privacyPolicy': {
        this.navigationService.openInNewTab("privacy-policy");
        break;
      }
      case 'tnc': {
        this.navigationService.openInNewTab("term-conditions");
        break;
      }
      case 'setting': {
        this.navigationService.navigate(["settings"]);
        break;
      }
      default: {
        this.navigationService.navigateByUrl("/");
        break;
      }
    }
  }

  showScannerDialog() {
    this.qrScannerService.show(true, false);
  }

  ngOnDestroy() {
    this.sub?.unsubscribe();
    this.user$?.unsubscribe();
  }

  onWhatsappFail(event: any) {
    if (event === true) {
      this.dialogPosition = 'center';
      this.isDialogCenter = true;
    } else {
      this.dialogPosition = 'bottom';
      this.isDialogCenter = false;
    }
  }
}
